import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './PaymentConfigurationFooter.css';
import PreviewConfigurationModal from '../PreviewConfigurationModal';

class PaymentConfigurationFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPreviewConfigurationModal: false,
    };
  }

  handlePreviewConfigurationOpen = () => {
    this.setState({
      showPreviewConfigurationModal: true,
    });
  };

  handlePreviewConfigurationClose = () => {
    this.setState({
      showPreviewConfigurationModal: false,
    });
  };

  render() {
    const {
      onCancelClick,
      onSaveClick,
      canDelete,
      canSubmit,
      onDeleteClick,
      selectedIds,
      paymentMethods,
    } = this.props;
    const { showPreviewConfigurationModal } = this.state;

    const selectedPaymentMethods = paymentMethods.filter(paymentMethod =>
      selectedIds.includes(paymentMethod.id)
    );

    return (
      <div>
        {showPreviewConfigurationModal && (
          <PreviewConfigurationModal
            isShowing
            onClose={this.handlePreviewConfigurationClose}
            selectedPaymentMethods={selectedPaymentMethods}
          />
        )}
        <div className={styles.previewBar}>
          <button
            type="button"
            className={classNames(
              'btn btn-default btn-block',
              styles.previewButton,
              'paycon-ftue-preview-button'
            )}
            onClick={this.handlePreviewConfigurationOpen}
          >
            Preview Configuration
          </button>
        </div>

        <div className={styles.actions}>
          <div>
            <button
              type="button"
              className="btn btn-danger"
              disabled={!canDelete}
              onClick={onDeleteClick}
            >
              <i className="fa fa-trash" />
            </button>
          </div>

          <div className={styles.actionsRight}>
            <button
              type="button"
              className="btn btn-default"
              onClick={onCancelClick}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary paycon-ftue-save-button"
              onClick={onSaveClick}
              disabled={!canSubmit}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    );
  }
}

PaymentConfigurationFooter.defaultProps = {
  onCancelClick: () => {},
  onDeleteClick: () => {},
  onSaveClick: () => {},
  canDelete: true,
  canSubmit: true,
  paymentMethods: [],
};

export default PaymentConfigurationFooter;
